import { render, staticRenderFns } from "./CompanyComplaint.vue?vue&type=template&id=785247fb&"
import script from "./CompanyComplaint.vue?vue&type=script&lang=js&"
export * from "./CompanyComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports